import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  SmsAnalyticsFilters,
  SmsBasicAnalytics,
  SmsConfiguration,
  SmsTemplate,
} from '../../entities/campaign-sms.model';
import { DashboardApiService } from '../db-api.service';

@Injectable({
  providedIn: 'root',
})
export class SmsApiService extends DashboardApiService {
  get organizationUrl(): string {
    return `/v1/issuer/organizations/${this.embedding.departmentId}`;
  }

  loadSmsConfiguration(): Observable<SmsConfiguration> {
    const url = `${this.organizationUrl}/sms_configuration`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  requestSmsAccess(): Observable<SmsConfiguration> {
    const url = `${this.organizationUrl}/sms_configuration`;

    return this._post(url, {}).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  loadSmsTemplates(): Observable<SmsTemplate[]> {
    const url = `${this.organizationUrl}/sms_templates`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'sms_templates')),
      catchError((res) => this._handleError(res)),
    );
  }

  loadBasicSmsAnalytics(filters: SmsAnalyticsFilters): Observable<SmsBasicAnalytics> {
    let url = `/v1/analytics/organizations/${this.embedding.departmentId}/campaign_sms_basic_analytics`;
    url += this._getAnalyticsParams(filters);

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  private _getAnalyticsParams(filters: SmsAnalyticsFilters): string {
    const params = new URLSearchParams();

    Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== null)
      .forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => params.append(`${key}[]`, val));
        } else {
          params.set(key, value);
        }
      });

    return params.toString() ? `?${params.toString()}` : '';
  }
}
